import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

/** WYSIWYG PDF — same pixels as on-screen report (export CSS hides actions). */
export async function downloadVerifyReportPdfFromElement(
  root: HTMLElement,
  filename: string,
): Promise<void> {
  root.classList.add('vr-report--export-pdf', 'vr-report--pdf-capture')
  await new Promise<void>((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()))
  })

  try {
    const canvas = await html2canvas(root, {
      scale: Math.min(2, window.devicePixelRatio || 1.5),
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
      scrollX: 0,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.clientWidth,
      onclone: (doc) => {
        doc.querySelectorAll('.vr-verdict-card').forEach((el) => {
          if (!(el instanceof HTMLElement)) return
          el.style.backgroundColor = '#ffffff'
          el.style.opacity = '1'
        })
      },
    })

    const dataUrl = canvas.toDataURL('image/png')
    const pdf = new jsPDF({ orientation: 'p', unit: 'pt', format: 'a4' })
    const pageWidth = pdf.internal.pageSize.getWidth()
    const pageHeight = pdf.internal.pageSize.getHeight()
    const margin = 20
    const contentWidth = pageWidth - margin * 2
    const imgHeight = (canvas.height * contentWidth) / canvas.width

    let offsetY = margin
    let remaining = imgHeight

    pdf.addImage(dataUrl, 'PNG', margin, offsetY, contentWidth, imgHeight)
    remaining -= pageHeight - margin * 2

    while (remaining > 0) {
      pdf.addPage()
      offsetY = margin - (imgHeight - remaining)
      pdf.addImage(dataUrl, 'PNG', margin, offsetY, contentWidth, imgHeight)
      remaining -= pageHeight - margin * 2
    }

    pdf.save(filename)
  } finally {
    root.classList.remove('vr-report--export-pdf', 'vr-report--pdf-capture')
  }
}
